export default {"src":"/_next/static/media/no-doubts.763d671b.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};